import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const FeeStructure = () => {  
  useEffect(() => {
    document.title = 'Fee Structure - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Fee Structure</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12 mand_dis_sec">
                    <div className="innertable">
                    <p><strong>NEW STUDENTS (At the time of admission)</strong></p>
                    <div className="table-responsive maintable">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>Admission fee</td>
                          <td>3000</td>
                        </tr>
                        <tr>
                          <td>Development fee</td>
                          <td>20000</td>
                        </tr>
                        <tr>
                          <td>Registration fee</td>
                          <td>500</td>
                        </tr> 
                        <tr>
                          <td>Total</td>
                          <td>23500</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                    <div className="clr20"></div>
                    <p><strong>School Fee Structure 2025-2026</strong></p>
                    <div className="table-responsive maintable">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Class</th>
                          <th>Tuition Fee</th>
                          <th>Amalgamated Fee</th>
                          <th>Smart Class</th>
                          <th>Campus Care</th>
                          <th>Child Welfare</th>
                          <th>Lab Fee</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Nursery-LKG-UKG</td>
                          <td>33840</td>
                          <td>5990</td>
                          <td>1980</td>
                          <td>1140</td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>43010</strong></td>
            
                        </tr>
                        <tr>
                          <td>I-II</td>
                          <td>34080</td>
                          <td>5990</td>
                          <td>1980</td>
                          <td>1140</td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>43250</strong></td>
                        </tr>
                        <tr>
                          <td>III-V</td>
                          <td>34080 </td>
                          <td>6420</td>
                          <td>1980</td>
                          <td>1140</td>
                          <td>60 </td>
                          <td>*</td>
                          <td><strong>43680</strong></td>
                        </tr>
                        <tr>
                          <td>VI-X</td>
                          <td>34800
                          </td>
                          <td>6420 </td>
                          <td>1980 </td>
                          <td>1140 </td>
                          <td>60 </td>
                          <td>*</td>
                          <td><strong>44400</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Com</td>
                          <td>43680
                          </td>
                          <td>6600 </td>
                          <td>1080 </td>
                          <td>1200 </td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>52620</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Arts </td>
                          <td>43680
                          </td>
                          <td>6600 </td>
                          <td>1080 </td>
                          <td>1200 </td>
                          <td>60 </td>
                          <td>*</td>
                          <td><strong>52620</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII SCI</td>
                          <td>43680
                          </td>
                          <td>6600 </td>
                          <td>1080 </td>
                          <td>1200 </td>
                          <td>60 </td>
                          <td>1680 </td>
                          <td><strong>54300</strong></td>
                        </tr>
                      </tbody>
                    </table>
               </div>
                    <div className="clr20"></div>
                    <h3>FEE STRUCTURE OF LKG TO XII 2025-2026</h3>
                    <p><strong>Fee Structure 2025-2026 (1st Installment)</strong></p>
                    <div className="table-responsive maintable">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Class</th>
                          <th>Tuition Fee</th>
                          <th>Amalgamated Fee</th>
                          <th>Smart Class</th>
                          <th>Campus Care</th>
                          <th>Child welfare</th>
                          <th>Lab fee</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
            
                        <tr>
                          <td>NURSERY-LKG-UKG
                          </td>
                          <td>8460 </td>
                          <td>5990 </td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>60 </td>
                          <td>*</td>
                          <td><strong>15290</strong></td>
                        </tr>
                        <tr>
                          <td>I-II </td>
                          <td>8520
                          </td>
                          <td>5990 </td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>60 </td>
                          <td>*</td>
                          <td><strong>15350</strong></td>
                        </tr>
                        <tr>
                          <td>III-V</td>
                          <td>8520
                          </td>
                          <td>6420 </td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>15780</strong></td>
                        </tr>
                        <tr>
                          <td>VI-X</td>
                          <td>8700
                          </td>
                          <td>6420 </td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>15960</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Com</td>
                          <td>10920
                          </td>
                          <td>6600</td>
                          <td>270 </td>
                          <td>300</td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>18150</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Arts</td>
                          <td>10920
                          </td>
                          <td>6600 </td>
                          <td>270 </td>
                          <td>300 </td>
                          <td>60</td>
                          <td>*</td>
                          <td><strong>18150</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII SCI </td>
                          <td>10920
                          </td>
                          <td>6600 </td>
                          <td>270 </td>
                          <td>300 </td>
                          <td>60</td>
                          <td>420 </td>
                          <td><strong>18570</strong></td>
                        </tr>
                      </tbody>
                    </table>
                </div>
            
            
                    <div className="clr20"></div>
                    <p><strong>Fee Structure 2025-2026 (2nd, 3rd &amp; 4th Installment)</strong></p>
                    <div className="table-responsive maintable">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Class </th>
                          <th>Tuition Fee</th>
                          <th>Amalgamated Fee</th>
                          <th>Smart Class</th>
                          <th>Campus Care</th>
                          <th>Child Welfare</th>
                          <th>Lab Fee</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
            
                        <tr>
                          <td>Nursery -LKG-UKG</td>
                          <td>8460
                          </td>
                          <td>0</td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>9240</strong></td>
                        </tr>
                        <tr>
                          <td>I-II</td>
                          <td>8520
                          </td>
                          <td>0</td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>9300</strong></td>
                        </tr>
                        <tr>
                          <td>III-V</td>
                          <td>8520
                          </td>
                          <td>0</td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>9300</strong></td>
                        </tr>
                        <tr>
                          <td>VI-X</td>
                          <td>8700
                          </td>
                          <td>0</td>
                          <td>495 </td>
                          <td>285 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>9480</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Com</td>
                          <td>10920
                          </td>
                          <td>0</td>
                          <td>270 </td>
                          <td>300 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>11490</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII Arts</td>
                          <td>10920
                          </td>
                          <td>0</td>
                          <td>270 </td>
                          <td>300 </td>
                          <td>0</td>
                          <td>0</td>
                          <td><strong>11490</strong></td>
                        </tr>
                        <tr>
                          <td>XI-XII SCI</td>
                          <td>10920
                          </td>
                          <td>0</td>
                          <td>270 </td>
                          <td>300 </td>
                          <td>0</td>
                          <td>420</td>
                          <td><strong>11910</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default FeeStructure;
